import React from 'react';

interface Props {
  onBack: () => void;
}

export const TalkToTaskTerms: React.FC<Props> = ({ onBack }) => {
  return (
    <div className="bg-slate-50 min-h-full font-sans">
      <nav className="bg-white border-b border-slate-100 px-6 py-4 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
           <h1 className="font-bold text-xl text-slate-900 tracking-tight">TalkToTask</h1>
           <button onClick={onBack} className="text-sm font-medium text-slate-600 hover:text-slate-900">
             Home
           </button>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="prose prose-slate max-w-none bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-100">
          <h1 className="text-3xl font-extrabold text-slate-900 mb-2">Terms of Service for TalkToTask</h1>
          <p className="text-sm text-slate-500 mb-8 font-medium">Effective Date: 15th February, 2026</p>
          
          <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-8 text-sm">
              <p className="mb-1"><span className="font-bold text-slate-700">Developer/Owner:</span> Chukwuemeka John Okparaeke</p>
              <p className="mb-0"><span className="font-bold text-slate-700">App Name:</span> TalkToTask</p>
          </div>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">1. Acceptance of Terms</h2>
          <p>
            By downloading or using the app, these terms will automatically apply to you. Users should read them carefully before using the app.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">2. Use License</h2>
          <ul className="list-disc pl-5 space-y-2 text-slate-700">
            <li>TalkToTask grants you a personal, non-transferable, non-exclusive license to use the software on your devices.</li>
            <li>You must not copy, modify, or attempt to extract the source code of the app.</li>
          </ul>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">3. User-Generated Content</h2>
          <ul className="list-disc pl-5 space-y-2 text-slate-700">
            <li>Users retain ownership of the content (audio notes, transcripts, tasks) they create.</li>
            <li>The app is a tool for processing this content locally. We do not claim ownership of your ideas or data.</li>
          </ul>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">4. Subscriptions & Payments</h2>
          <ul className="list-disc pl-5 space-y-2 text-slate-700">
            <li><strong>TalkToTask Pro:</strong> Some features (like unlimited recording, Magic Pen styles) are available via paid subscription.</li>
            <li><strong>Billing:</strong> Payments are processed through the Apple App Store / Google Play Store via RevenueCat.</li>
            <li><strong>Cancellation:</strong> You can cancel your subscription at any time through your device's account settings.</li>
          </ul>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">5. AI Accuracy Disclaimer</h2>
          <p className="text-slate-800 font-semibold mb-2">Important:</p>
          <p>
            The artificial intelligence (AI) used for transcription and summarization is experimental and may produce errors or inaccuracies.
          </p>
          <p>
            TalkToTask is not responsible for any actions taken based on incorrect AI-generated information. Users should always verify important details.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">6. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Chukwuemeka John Okparaeke shall not be liable for any indirect, incidental, or consequential damages arising out of your use of the app.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">7. Changes to Terms</h2>
          <p>
            We may update our Terms and Conditions from time to time. You are advised to review this page periodically for any changes.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">8. Contact Us</h2>
          <p>
            If you have any questions or suggestions about our Terms and Conditions, do not hesitate to contact us at:
          </p>
          <div className="mt-4 p-4 bg-indigo-50 border-l-4 border-indigo-500 rounded-r-lg">
             <a href="mailto:mactrixapp@gmail.com" className="text-indigo-800 underline font-medium hover:text-indigo-600">mactrixapp@gmail.com</a>
          </div>
        </div>
        
        <div className="mt-12 text-center pb-8">
            <a href="/" onClick={(e) => { e.preventDefault(); onBack(); }} className="text-slate-500 hover:text-brand-600 font-medium transition-colors border-b border-transparent hover:border-brand-600 pb-0.5">
                ← Back to Home
            </a>
        </div>
      </main>
    </div>
  );
};